module.exports = __webpack_public_path__ + "img/devices.493eabf1.svg";